// extracted by mini-css-extract-plugin
export default {"root":"nested_tabs-module___root___b9e38300","button":"nested_tabs-module___button___a48ffd0e","selected":"nested_tabs-module___selected___ccda04c1"};